import React, { useEffect } from 'react'
import { GrowthBookProvider as GBProvider, useGrowthBook as useGBHook } from '@growthbook/growthbook-react'
import { growthbook, loadGrowthBookFeatures } from '../lib/growthbook'
import { useAuth } from '../hooks/useAuth'

export const GrowthBookProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { country, user } = useAuth()

  useEffect(() => {
    void loadGrowthBookFeatures(country)
  }, [country, user]) // Reload when country or user changes

  // Always pass the growthbook instance, even if not fully loaded yet
  return <GBProvider growthbook={growthbook}>{children}</GBProvider>
}

// Re-export the official GrowthBook hook
export const useGrowthBook = useGBHook
